import { useDocumentTitle } from '@/hooks/useDocumentTitle';

interface PlaceholderProps {
  title: string;
  hint?: string;
}

function Placeholder({ title, hint }: PlaceholderProps): JSX.Element {
  return (
    <main className="container py-12">
      <h1 className="text-3xl font-semibold">{title}</h1>
      {hint ? <p className="mt-3 text-muted-foreground">{hint}</p> : null}
    </main>
  );
}

export function AdminPage(): JSX.Element {
  useDocumentTitle('Admin · PA-Tracker');
  return (
    <Placeholder
      title="Admin-Konsole"
      hint="Wartung & Schuljahres-Reset — wird ab Prompt 14 ausgebaut."
    />
  );
}

export function NotFoundPage(): JSX.Element {
  useDocumentTitle('Seite nicht gefunden · PA-Tracker');
  return <Placeholder title="404 — Seite nicht gefunden" />;
}
